import { render } from "./ReportGroupList.vue?vue&type=template&id=3d18544e"
import script from "./ReportGroupList.vue?vue&type=script&lang=js"
export * from "./ReportGroupList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/ReportGroupList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d18544e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d18544e', __exports__)) {
    api.reload('3d18544e', __exports__)
  }
  
  module.hot.accept("./ReportGroupList.vue?vue&type=template&id=3d18544e", () => {
    api.rerender('3d18544e', render)
  })

}


export default __exports__